import React from "react";
import PropTypes from "prop-types";
//widgets
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from "@material-ui/core/CircularProgress";

class Loading extends React.Component {
  render() {
    const { classes } = this.props;

    return <CircularProgress size={48} className={classes.buttonProgress} />;
  }
}

Loading.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -24,
    marginLeft: -24,
  },
});

export default withStyles(styles, { withTheme: true })(Loading);
